module.exports = __webpack_public_path__ + "static/media/hygy.51684f2a.mp4";